import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { bufferTime, catchError, filter, mergeMap, switchMap } from 'rxjs/operators';

import { CommonEpic } from 'common/types/redux';

import stocksActionTypes from './stocks.actionTypes';
import * as stocksActions from './stocks.actions';
import * as stocksApi from './stocks.api';

export const epicGetStocks: CommonEpic<typeof stocksApi> = (action$, _state$, { api }) =>
  action$.pipe(
    ofType(stocksActionTypes.LOADING_GET_STOCKS),
    mergeMap(() =>
      from(api.getStocks()).pipe(
        mergeMap((response) =>
          of(stocksActions.actionSuccessGetStocks(response), stocksActions.actionGetStocksGroups()),
        ),
        catchError((error) => of(stocksActions.actionErrorGetStocks(error))),
      ),
    ),
  );

export const epicGetStocksGroups: CommonEpic<typeof stocksApi> = (action$, _state$, { api }) =>
  action$.pipe(
    ofType(stocksActionTypes.LOADING_GET_STOCKS_GROUPS),
    mergeMap(() =>
      from(api.getStocksGroups()).pipe(
        mergeMap((response) => {
          const { isAuthenticated } = _state$.value.common.user;
          if (isAuthenticated)
            return of(stocksActions.actionSuccessGetStocksGroups(response), stocksActions.actionGetFavoriteStocks());
          return of(stocksActions.actionSuccessGetStocksGroups(response));
        }),
        catchError((error) => of(stocksActions.actionErrorGetStocksGroups(error))),
      ),
    ),
  );

export const epicGetFavoriteStocks: CommonEpic<typeof stocksApi> = (action$, _state$, { api }) =>
  action$.pipe(
    ofType(stocksActionTypes.LOADING_GET_FAVORITE_STOCKS),
    mergeMap(() =>
      from(api.getFavoriteStocks()).pipe(
        mergeMap((response) => of(stocksActions.actionSuccessGetFavoriteStocks(response))),
        catchError((error) => of(stocksActions.actionErrorGetFavoriteStocks(error))),
      ),
    ),
  );

export const epicSetFavoriteStock: CommonEpic<typeof stocksApi> = (action$, _state$, { api }) =>
  action$.pipe(
    ofType(stocksActionTypes.LOADING_SET_FAVORITE_STOCKS),
    mergeMap((action) => {
      const { favorites } = _state$.value.stocksReducer;
      const endpoint = () =>
        favorites.includes(action.payload)
          ? api.deleteFavoriteStocks(action.payload)
          : api.setFavoriteStocks(action.payload);
      return from(endpoint()).pipe(
        mergeMap((response) =>
          of(stocksActions.actionSuccessSetFavoriteStocks(response), stocksActions.actionGetFavoriteStocks()),
        ),
        catchError((error) => of(stocksActions.actionErrorSetFavoriteStocks(error))),
      );
    }),
  );

export const epicGetStocksTrend: CommonEpic<typeof stocksApi> = (action$, _state$, { api }) =>
  action$.pipe(
    ofType(stocksActionTypes.LOADING_GET_STOCKS_TREND),
    bufferTime(2000),
    filter((stream) => !!stream.length),
    switchMap((actionsCollection) => {
      const codes = actionsCollection.reduce((acc: string[], curr) => [...acc, ...curr.payload], []);
      return from(api.getStocksDailyCandles(codes)).pipe(
        mergeMap((response) => of(stocksActions.actionSuccessGetStocksTrend(response.data || []))),
        catchError((error) => of(stocksActions.actionErrorGetStocksTrend(error))),
      );
    }),
  );
